import { useEffect, useState } from 'react';
import { getAdminDashboardCounts, type AdminDashboardCounts } from '../../lib/api';

export function DashboardPage() {
  const [counts, setCounts] = useState<AdminDashboardCounts | null>(null);

  useEffect(() => {
    getAdminDashboardCounts().then(setCounts).catch(() => setCounts(null));
  }, []);

  return (
    <>
      <header className="admin-page-heading"><p className="admin-kicker">Overview</p><h1>Dashboard</h1></header>
      <section className="admin-stat-grid" aria-label="Inbox and catalog counts">
        <div className="admin-stat"><strong>{counts?.new_inquiries ?? '—'}</strong><span>New messages</span></div>
        <div className="admin-stat"><strong>{counts?.published_posts ?? '—'}</strong><span>Published posts</span></div>
        <div className="admin-stat"><strong>{counts?.published_items ?? '—'}</strong><span>Catalog items</span></div>
      </section>
      <section className="admin-card-grid" aria-label="Admin sections">
        <a href="/admin/inquiries"><strong>Inquiries</strong><span>Review saved customer messages</span></a>
        <a href="/admin/pages"><strong>Additional pages</strong></a>
        <a href="/admin/media"><strong>Media</strong><span>Manage approved imagery and files</span></a>
      </section>
    </>
  );
}
